
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationObserver } from 'vee-validate';
import moment from 'moment';
import { WEEKDAYS } from '@/util/constant';
import { toLocaleTime, getUtcTime } from '@/util/helper';

interface Time {
  weekday: number;
  deliveryAt: string | null;
  deliveryAtMenu: false;
}

@Component
export default class DeliveryTime extends Vue {
  @Prop({ type: String, default: '' }) public title!: string;

  public $refs!: {
    observer: InstanceType<typeof ValidationObserver>;
  };
  public hours: Time[] = [];

  get weekdays() {
    const days = WEEKDAYS(this.$i18n);

    return days.map((day, index) => {
      return { value: index, text: day };
    });
  }

  public addOpeningHour() {
    this.hours.push({
      weekday: 0,
      deliveryAt: null,
      deliveryAtMenu: false,
    });
  }

  public getHours() {
    return this.hours.map((h: Time) => {
      return {
        ...h,
        deliveryAt: getUtcTime(h.deliveryAt!),
      };
    });
  }

  public setHours(hours: Time[], overwrite: boolean = false): void {
    if (overwrite) {
      this.hours = [];
    }
    for (const hour of hours) {
      this.hours.push({
        weekday: hour.weekday,
        deliveryAtMenu: false,
        // @ts-ignore
        deliveryAt: toLocaleTime(hour.deliveryAt),
      });
    }
  }

  public removeHour(item: Time) {
    this.hours.splice(this.hours.indexOf(item), 1);
  }

  public validate(): Promise<boolean> {
    return this.$refs.observer.validate();
  }
}
